'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrainingGroups = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TrainingGroups, _Component);

  function TrainingGroups() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TrainingGroups);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TrainingGroups.__proto__ || (0, _getPrototypeOf2.default)(TrainingGroups)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      data.reason = 'sportovni-pripravka';
      _this.props.saveEmail(data).then(function () {
        window.alert('Děkujeme za váš e-mail, budeme vás na něj v brzké době informovat!');
      }).catch(function () {
        window.alert('Je nám líto, ale někde se stala chyba :( Zkuste to prosím ještě jednou nebo napište na info@nenudimse.cz.');
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TrainingGroups, [{
    key: 'render',
    value: function render() {
      var styles = require('./TrainingGroups.scss');
      var styles2 = require('./../Camps/Camps.scss');
      var photoIntro = require('./training-groups-intro.jpg');
      var photo1 = require('./training-groups1.jpg');
      var photo2 = require('./training-groups2.jpg');
      var photo3 = require('./training-groups3.jpg');

      var data = {
        dates: [{
          url: '/sportovni-pripravka/omska-praha-10',
          title: 'Sportovní přípravka na gymnáziu Omská, Praha 10',
          date: 'Úterý a čtvrtek',
          place: 'Omská, Praha 10',
          rest: 20
        }, {
          url: '/sportovni-pripravka/zs-bitovska-praha-4',
          title: 'Míčové hry, atletika a gymnastika',
          date: 'Středa',
          place: 'ZŠ Bítovská, Praha 4',
          rest: 20
        }],
        intro: {
          text: 'Ve sportovní přípravce učíme děti během školního roku běhat, skákat a házet. Dáváme jim všestranný základ pro kterýkoli sport, takže si v pozdějším věku mohou ze sportu vybírat.',
          image: {
            src: photoIntro,
            alt: 'Sportovní přípravka pro všechny'
          }
        },
        photos: {
          heading: 'Fotky ze sportovní přípravky',
          photo1: {
            src: photo1,
            alt: 'Sportovní přípravka'
          },
          photo2: {
            src: photo2,
            alt: 'Sportovní přípravka pro děti'
          },
          photo3: {
            src: photo3,
            alt: 'Sportovní přípravka pro začátečníky i pokročilé'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'Sportovn\xED p\u0159\xEDpravka, kde d\u011Bti sportuj\xED po cel\xFD rok',
          meta: [{
            name: 'description',
            content: 'Sportovní přípravka, kde naučíme děti běhat, skákat, házet a především se radovat z pohybu. Těšíme se na začátečníky i malé šampiony.'
          }, {
            property: 'og:description',
            content: 'Sportovní přípravka, kde naučíme děti běhat, skákat, házet a především se radovat z pohybu. Těšíme se na začátečníky i malé šampiony.'
          }, {
            property: 'og:title',
            content: 'Sportovní přípravka, kde děti sportují po celý rok'
          }, {
            name: 'keywords',
            content: 'sport, sport dětí, sportovní přípravka, sport pro děti, atletika, běhaní, sportovní kroužek'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/sportovni-pripravka' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'Sportovn\xED p\u0159\xEDpravka, ',
            _react2.default.createElement(
              'small',
              null,
              'kde d\u011Bti sportuj\xED cel\xFD rok'
            )
          ),
          _Content2.default.renderDates(styles, data.dates)
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _Content2.default.renderPhotos(styles2, data.photos),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Pro\u010D chodit do sportovn\xED p\u0159\xEDpravky?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Ve v\u011Bku 6-13 let mus\xED d\u011Bti pohyb p\u0159edev\u0161\xEDm bavit a mus\xED si k n\u011Bmu vybudovat pozitivn\xED vztah. Na\u0161e tr\xE9ninky jsou zam\u011B\u0159en\xE9 na v\u0161estrann\xFD pohybov\xFD rozvoj, b\u011Bhem kter\xFDch d\u011Btem v\u0161t\u011Bpujeme z\xE1kladn\xED motorick\xE9 dovednosti. D\u011Bti, kter\xE9 u n\xE1s tr\xE9nuj\xED, maj\xED dobr\xFD z\xE1klad pro ka\u017Ed\xFD sport. V budoucnu je pouze na nich, zda se budou v\u011Bnovat vrcholov\xE9mu sportu nebo vyu\u017Eij\xED tyto schopnosti v b\u011B\u017En\xE9m \u017Eivot\u011B.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Na koho se t\u011B\u0161\xEDme?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'T\u011B\u0161\xEDme se na holky a kluky, kte\u0159\xED se s n\xE1mi cht\u011Bj\xED bavit a n\u011Bco se nau\u010Dit. Nikoho do ni\u010Deho nenut\xEDme, chceme, aby si d\u011Bti pohyb u\u017E\xEDvaly a nenudily se.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Kde a kdy budeme sportovat?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'P\u0159esn\xE9 dny a \u010Dasy tr\xE9nink\u016F jsou zat\xEDm v jedn\xE1n\xED, m\u016F\u017Eeme ale s jistotou \u0159\xEDci, \u017Ee p\u0159\xEDpravkov\xE9 skupiny otev\u0159eme na Praze 4 - Mod\u0159any a na Praze 10.'
              )
            )
          )
        ),
        _Content2.default.renderDates(styles, data.dates, true)
      );
    }
  }]);
  return TrainingGroups;
}(_react.Component), _class.propTypes = {
  saveEmail: _react.PropTypes.func
}, _temp2);
exports.default = TrainingGroups;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroups/TrainingGroups.js
// module id = 1117
// module chunks = 0